import PullRequestIcon from '@atlaskit/icon/core/pull-request';
import * as React from 'react';

export function SvgPullRequest() {
  return <PullRequestIcon label="" testId="ads-refreshed-icon" />;
}
